<template>
  <header class="sticky top-0 z-40 flex-none w-full mx-auto bg-white border-b border-gray-200 dark:border-gray-600 dark:bg-gray-800">
    <div v-if="false" id="banner" class="z-50 flex justify-center w-full px-4 py-3 border border-b border-gray-200 bg-gray-50 dark:border-gray-600 lg:py-4 dark:bg-gray-700" tabindex="-1">
      <div class="items-center md:flex">
        <p class="text-sm font-medium text-gray-900 md:my-0 dark:text-white">
          <span class="bg-blue-100 text-blue-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded dark:bg-blue-200 dark:text-blue-800 hidden md:inline">New</span>
          We have launched Fleetwire Blocks featuring over 330+ website sections!
          <a class="inline-flex items-center ml-2 text-sm font-medium text-blue-600 md:ml-2 dark:text-blue-500 hover:underline" href="/blocks/">
            Check it out
            <svg aria-hidden="true" class="w-3 h-3 ml-1.5 text-blue-600 dark:text-blue-500" fill="none" viewBox="0 0 14 10" xmlns="http://www.w3.org/2000/svg">
              <path d="M1 5h12m0 0L9 1m4 4L9 9" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></path>
            </svg>
          </a>
        </p>
      </div>
    </div>

    <div class="flex items-center justify-between w-full px-3 py-3 mx-auto max-w-8xl lg:px-4">
      <div class="flex items-center">
        <div class="flex items-center justify-between">
          <a :href="navbarBrandUrl" class="flex">
            <img v-if="company.logo" :src="company.logo" alt="FlowBite Logo" class="h-8 mr-3">
            <span v-else>{{ company.name }}</span>
          </a>
        </div>
      </div>

      <div class="flex items-center">
        <v-btn v-if="allowCustomerLogin" size="small" variant="text">Customer Login</v-btn>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
import {computed, ref} from 'vue';
import {useCompany} from '@/composables/useCompany';
import getDefaultMeta from '@/utils/meta';

const {company} = useCompany();

const allowCustomerLogin = ref(false);

const navbarBrandUrl = computed(() => {
  const useCustom = getDefaultMeta('settings.branding.use_custom_brand_store_url');
  const slug = company.value?.slug ?? '';
  const storeUrl = getDefaultMeta('settings.branding.store_logo_url') as string | null;
  const defaultUrl = `/rental?company=${slug}`;
  const tracking = 'utm_source=fleetwire&utm_medium=logo&utm_campaign=fleetwire_navbar';

  if (!useCustom || !storeUrl) {
    return defaultUrl;
  }

  return storeUrl.includes('?') ? `${storeUrl}&${tracking}` : `${storeUrl}?${tracking}`;
});
</script>
